import { useFormContext } from 'react-hook-form'
import { companyTypeToFields } from 'api/companies/companyType'
import { useCompanyDetailContextValue } from 'pages/Company/CompanyDetail/context/CompanyDetailProvider'
import { useRequiresEverifySweepPreviewQuery } from 'queries/companies'
import { EditGeneralDetailsFlowSchema } from '../schemas/editGeneralDetailsFlowSchema'
import { getEverifySweepWarning } from '../utils/getEverifySweepWarning'

// Owns the sweep-preview query and derives the warning shown when E-Verify is newly turned on.
export const useEverifySweepWarning = (): string | null => {
  const { watch } = useFormContext<EditGeneralDetailsFlowSchema>()
  const {
    state: { id: companyId, requiresEverify: originalRequiresEverify },
  } = useCompanyDetailContextValue()

  const watchedType = watch('type')
  const isEnabling =
    companyTypeToFields(watchedType).requiresEverify && !originalRequiresEverify

  const { data: workersAffected, isFetching: isPreviewFetching } =
    useRequiresEverifySweepPreviewQuery(companyId, { enabled: isEnabling })

  return getEverifySweepWarning({
    isEnabling,
    workersAffected,
    isPreviewFetching,
  })
}
